import { _ } from "libs";

import React from "react";
import withRedux from "../../withRedux";
import { Profile } from "../../types";
import Modal from "../modal";
import { closeValidateProfilePopup, updateProfile } from "../../actions";
import { RootState } from "../../reducers";
import VerifyProfileForm from "../settings/verifyProfileForm";

function PlayerVerificationModal({
	show = false,
	profile = null,
	callback = null,
	updateProfile = null,
}: {
	show: boolean;
	profile: Profile;
	callback: Function;
	updateProfile: Function;
}) {
	if (show === false) {
		return null;
	}

	const close = () => {
		if (callback) {
			callback(false);
		}
		closeValidateProfilePopup();
	};

	const update = async (values) => {
		await updateProfile({
			...values,
			validatePhone: false,
			dispatchProfileUpdated: false,
		});
		closeValidateProfilePopup();
		callback(true);
	};

	if (profile === null) {
		return null;
	}

	return (
		<Modal title="" onCloseClicked={close} className="wide">
			<div className="horizontal">
				<div className="leader">
					<div className="illustration woman_holding_phone" />
				</div>
				<div className="content">
					<h1 className="mt-6 mb-2">{_("profile.verification.heading")}</h1>
					<p className="mb-6 large">{_("profile.verification.content")}</p>
					<VerifyProfileForm profile={profile} onChange={update} />
				</div>
			</div>
		</Modal>
	);
}

function mapStateToProps({ profile, reservation: { showCompleteProfile, callback } }: RootState) {
	return { show: showCompleteProfile === true, profile, callback };
}

export default withRedux({ updateProfile }, mapStateToProps)(PlayerVerificationModal);
